module.exports = __webpack_public_path__ + "static/environment-hero-desktop.2a421fe8.webp";